function Sports() {
}

export default Sports;